import { ServerTimeMessage } from "../../messages/session/SessionMessages";
import { busService } from "../bus";
class ServerTimeService {
    constructor() {
        this.connection = busService.connection("ChangingGeometrySyncService");
        this.avgTimeOffset = 0;
        this.handleServerTimeMessage = (msg, meta) => {
            this.avgTimeOffset = msg.avgServerTimeOffset + (Date.now() - meta.timeStamp);
        };
        this.connection.subscribeByType(ServerTimeMessage, this.handleServerTimeMessage);
    }
    getServerTime() {
        return new Date().getTime() + this.avgTimeOffset;
    }
}
export const serverTimeService = new ServerTimeService();
